import { Link } from "@tanstack/react-router";
import { Button, Typography } from "@vintecc/components";
import { FC } from "react";
import { useCommonTranslation } from "@/services/culture/common.translations";

export const NotFoundLayout: FC<{
  notFoundText?: string;
}> = ({ notFoundText }) => {
  const { t } = useCommonTranslation();

  return (
    <div className="flex flex-col items-center justify-center h-full gap-4">
      <div className="text-9xl font-bold text-grey-400">404</div>
      <Typography variant="h2">{t("layout.notFoundTitle")}</Typography>
      <Typography variant="p">{notFoundText ?? t("layout.notFoundDescription")}</Typography>
      <Link to="/">
        <Button variant="outline">{t("layout.goToHomepage")}</Button>
      </Link>
    </div>
  );
};
